import React from 'react';

import { IMAGES, COPY } from '../constants';
import styles from './fableticsUpgradeVersionOne.scss';

// The variant 1 upgrade creative re-uses the variant 1 banner's MOBILE Power
// hero asset at both breakpoints — the card geometry is image-left in both
// viewports here, unlike the home banner which switches to a desktop strip.

const FableticsUpgradeVersionOne = () => {
    return (
        <div
            className={styles.fableticsUpgradeVersionOne}
            data-testid="fabletics.upgrade-creative.version_one.container"
        >
            <div className={styles.card} data-testid="fabletics.upgrade-creative.version_one.power-card">
                <div className={styles.cardImageWrap}>
                    <img src={IMAGES.powerHeroMobile} alt="" className={`${styles.cardImage} ${styles.cardImagePower}`} />
                </div>
                <div className={styles.cardBody}>
                    <div className={styles.brandRow}>
                        <img src={IMAGES.powerIcon} alt="" className={styles.brandIcon} />
                        <span className={styles.brandLabelPower}>POWER</span>
                    </div>
                    <p className={styles.cardCopy}>
                        {COPY.powerCard}
                    </p>
                </div>
            </div>

            <p
                className={styles.includedSubhead}
                data-testid="fabletics.upgrade-creative.version_one.included-subhead"
            >
                Included with the Annual Plan
            </p>

            <div className={styles.cardGroup}>
                <div className={styles.card} data-testid="fabletics.upgrade-creative.version_one.fabletics-card">
                    <div className={styles.cardImageWrap}>
                        <img
                            src={IMAGES.tennisWomen}
                            alt=""
                            className={`${styles.cardImage} ${styles.cardImageFabletics}`}
                        />
                    </div>
                    <div className={styles.cardBody}>
                        <img
                            src={IMAGES.fableticsLogo}
                            alt="Fabletics"
                            className={styles.brandLogoFabletics}
                            data-testid="fabletics.upgrade-creative.version_one.fabletics-card.logo"
                        />
                        <p className={styles.cardCopy}>
                            {COPY.fableticsCard}
                        </p>
                    </div>
                </div>
                <p
                    className={styles.zipCaption}
                    data-testid="fabletics.upgrade-creative.version_one.zip-caption"
                >
                    USA billing ZIP required to access Fabletics.
                </p>
            </div>

            <div className={styles.card} data-testid="fabletics.upgrade-creative.version_one.gp-card">
                <div className={styles.cardImageWrap}>
                    <img
                        src={IMAGES.airport}
                        alt=""
                        className={`${styles.cardImage} ${styles.cardImageGp}`}
                    />
                </div>
                <div className={styles.cardBody}>
                    <img
                        src={IMAGES.gpLogo}
                        alt="Global Privileges"
                        className={styles.brandLogoGp}
                        data-testid="fabletics.upgrade-creative.version_one.gp-card.logo"
                    />
                    <p className={styles.cardCopy}>
                        {COPY.gpCard}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default FableticsUpgradeVersionOne;
